module.exports = __webpack_public_path__ + "static/neos-7b5dd7ab69144efea792de0163ab2ef8.jpeg";